import { MenuItem, Popover, Typography } from "@mui/material";

export enum DocumentOrigin {
  COMPUTER = 1,
  SELECTABLE_DOCUMENTS = 2,
}

export interface IUploadFileFieldPopoverOriginProps {
  open: boolean;
  anchorEl: HTMLElement | null;
  labelSelectFromSelectableDocuments: string;
  labelSelectFromComputer: string;
  onSelectDocumentOrigin: (origin: DocumentOrigin) => void;
  onClose: () => void;
}

export const UploadFileFieldPopoverOrigin = ({
  open,
  anchorEl,
  labelSelectFromSelectableDocuments,
  labelSelectFromComputer,
  onSelectDocumentOrigin,
  onClose,
}: IUploadFileFieldPopoverOriginProps) => {
  return (
    <Popover
      open={open}
      onClose={onClose}
      anchorEl={anchorEl}
      anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
      slotProps={{ paper: { variant: "outlined", elevation: 0, sx: { borderRadius: 0 } } }}
    >
      <MenuItem onClick={() => onSelectDocumentOrigin(DocumentOrigin.SELECTABLE_DOCUMENTS)}>
        <Typography variant="body1">{labelSelectFromSelectableDocuments}</Typography>
      </MenuItem>
      <MenuItem onClick={() => onSelectDocumentOrigin(DocumentOrigin.COMPUTER)}>
        <Typography variant="body1">{labelSelectFromComputer}</Typography>
      </MenuItem>
    </Popover>
  );
};
